const parseString = (str: string): number | string | boolean => {
  try {
    return JSON.parse(str);
  } catch (error) {
    return str;
  }
};

export default parseString;
